import PageHero from "../components/PageHero";
import RoutineTable from "../components/RoutineTable";

export default function RoutinePage() {
  return (
    <div data-testid="routine-page">
      <PageHero label="Timetable" title="Class Routine" subtitle="The weekly class routine for every semester — including subject, room number and teacher. Download it as a PDF." />
      <RoutineTable />
    </div>
  );
}
